import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BidItemsInterface, BidPdfInitialState, BidsItems } from '../types';
import { BidPdfDetailsResponseData } from './types';

const initialState: BidPdfInitialState = {
  bidFieldsValue: {} as BidItemsInterface,
  bidTableData: [],
  isLoading: true,
  bidPdfDetailsData: {} as BidPdfDetailsResponseData,
  bidPdfAdditionalItems: [],
};

export const bidPdfSlice = createSlice({
  name: 'bidPdf',
  initialState,
  reducers: {
    resetBidPdfSlice() {
      return initialState;
    },
    setBidPdfValues(state, action: PayloadAction<BidItemsInterface>) {
      return {
        ...state,
        bidFieldsValue: action.payload,
      };
    },
    setBidPdfTableData(state, action: PayloadAction<BidsItems[]>) {
      return {
        ...state,
        bidTableData: action.payload,
      };
    },
    getBidPdfDetailsData(state, _action) {
      return {
        ...state,
        isLoading: true,
      };
    },
    getBidPdfDetailsDataSuccess(state, action: PayloadAction<BidPdfDetailsResponseData>) {
      return {
        ...state,
        bidPdfDetailsData: action.payload,
        bidPdfAdditionalItems: action.payload.ManualAddedServices,
        isLoading: false,
      };
    },
    getBidPdfDetailsDataFailure(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
    setAdditionalItems(state, action: PayloadAction<object[]>) {
      return {
        ...state,
        bidPdfAdditionalItems: action.payload,
      };
    },
    saveAdditionalServices(state, _action: PayloadAction<{ pay: object, bidItems: object[] }>) {
      return {
        ...state,
        isLoading: true,
      };
    },
    saveAdditionalServicesSuccess(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    saveAdditionalServicesFailure(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

export const {
  setBidPdfValues, setBidPdfTableData,
  getBidPdfDetailsData, getBidPdfDetailsDataSuccess, getBidPdfDetailsDataFailure, resetBidPdfSlice,
  saveAdditionalServices, saveAdditionalServicesSuccess, saveAdditionalServicesFailure, setAdditionalItems,
} = bidPdfSlice.actions;
export const bidPdfSliceReducer = bidPdfSlice.reducer;

export type BidPdfActions =
  | ReturnType<typeof setBidPdfValues>
  | ReturnType<typeof setBidPdfTableData>
  | ReturnType<typeof getBidPdfDetailsData>
  | ReturnType<typeof getBidPdfDetailsDataSuccess>
  | ReturnType<typeof getBidPdfDetailsDataFailure>
  | ReturnType<typeof resetBidPdfSlice>
  | ReturnType<typeof saveAdditionalServices>
  | ReturnType<typeof saveAdditionalServicesSuccess>
  | ReturnType<typeof saveAdditionalServicesFailure>
  | ReturnType<typeof setAdditionalItems>;
